import Loader from "../../../components/Loader";
import React, { useState, useEffect, useRef } from "react";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { DeliveryData, InvoiceData, Order } from "../OrderHistory";
import Modal, { ModalOrderData } from "./Models";
import DeliveryModal from "./DeliveryModal";
import InvoiceModal from "./InvoiceModal";
import UpArrow from "../../../assets/up-arrow.svg";
import DownArrow from "../../../assets/down-arrow.svg";
import { useTranslation } from "react-i18next";
import down from "../../../assets/down.svg";
import left from "../../../assets/left.svg";
import { currentLang } from "../../../utility/index";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { deleteFullProduct } from "../api/createOrder";
import { toast, ToastContainer } from "react-toastify";
import { useZamzamError } from "../context/ZamzamErrorContext";
interface OrderTableProps {
  tableData: Order[];
  loading: boolean;
  setLoading: (value: boolean) => void;
  handleShowModal: (orderId: number) => void;
  showModal: boolean;
  handleHideModal: () => void;
  data: ModalOrderData | undefined;
  printData: () => void;
  handleShowDeliveryModal: (orderId: number, value: any) => void;
  showDeliveryModal: boolean;
  deliveryModalData: DeliveryData | undefined;
  handleHideDeliveryModal: () => void;
  printDelivery: () => void;

  handleShowInvoiceModal: (orderId: number) => void;
  invoiceModalData: InvoiceData | undefined;
  showInvoiceModal: boolean;
  handleHideInvoiceModal: () => void;
  handlePrintData: () => void;
  refetch: boolean;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
}
const OrderTable: React.FC<OrderTableProps> = ({
  tableData,
  loading,
  setLoading,
  handleShowModal,
  showModal,
  handleHideModal,
  data,
  printData,
  handleShowDeliveryModal,
  showDeliveryModal,
  deliveryModalData,
  handleHideDeliveryModal,
  printDelivery,
  handleShowInvoiceModal,
  invoiceModalData,
  showInvoiceModal,
  handleHideInvoiceModal,
  handlePrintData,
  refetch,
  setRefetch,
}) => {
  const { showError } = useZamzamError();
  const [expandedRows, setExpandedRows] = useState<number[]>([]);
  const [menuOpen, setMenuOpen] = useState<number | null>(null);
  const [cancelReason, setCancelReason] = useState<string | null>(null);
  const [cancelReasonError, setCancelReasonError] = useState<boolean>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const toggleMenu = (index: number) => {
    if (index) setMenuOpen(index);
  };

  const toggleRow = (index: number) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const statusClasses = (status: string) => {
    switch (status) {
      case "PLACED":
        return "bg-green-100 text-green-800 border-green-800";
      case "CONFIRMED":
        return "bg-yellow-100 text-yellow-800 border-yellow-800";
      case "SHIPPED":
        return "bg-red-100 text-red-800 border-red-800";
      case "DELIVERED":
        return "bg-blue-100 text-blue-800 border-blue-800";
      case "INVOICED":
        return "bg-[#f1d4ff] text-[#bf5cf4] border-[#bf5cf4]";
      case "CANCELLED":
        return "bg-[#ffe6e6] text-[#d32f2f] border-[#d32f2f]";

      case "PENDING":
        return "bg-[#fdebd3] text-[#f5a623] border-[#f5a623]";

      default:
        return "";
    }
  };

  const formatDateTime = (isoString: string, type: string): string => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;

    if (type === "date") {
      return `${day}/${month}/${year}`;
    } else {
      return `${day}/${month}/${year} - ${formattedHours}:${minutes} ${amPm}`;
    }
  };
  const [lang, setLang] = useState<string | null>(null);

  const handleEditMedia = () => {
    if (menuOpen === null) return;
    navigate(URL_MAPPING.EDITORDERHISTORY(String(menuOpen)));
  };
  const handleDeleteOrder = async (orderId: any) => {
    try {
      if (cancelReason === null) {
        setCancelReasonError(true);
        return;
      }

      const response = await deleteFullProduct(orderId, cancelReason);
      toast.success(
        lang === "Arabic" ? "تم الحذف بنجاح" : "Cancelled Successfully"
      );
      setTimeout(() => {
        setRefetch(!refetch);
      }, 3000);
      setLoading(true);
      setMenuOpen(null);
    } catch (error: any) {
      setMenuOpen(null);
      setTimeout(() => {
        setRefetch(!refetch);
      }, 3000);
      showError(
        error,
        lang === "Arabic" ? "فشل إلغاء الطلب" : "Failed to cancel order"
      );
    }
  };

  useEffect(() => {
    const lang = currentLang();
    setLang(lang);
  }, []);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setMenuOpen(null); // Close menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  return (
    <>
      <ToastContainer />
      <div className="p-2 bg-gray-50">
        {showModal && (
          <Modal
            handleHideModal={handleHideModal}
            data={data}
            printData={printData}
          />
        )}
        {showDeliveryModal && (
          <DeliveryModal
            data={deliveryModalData}
            handleHideDeliveryModal={handleHideDeliveryModal}
            printDelivery={printDelivery}
          />
        )}
        <InvoiceModal
          isOpen={showInvoiceModal}
          data={invoiceModalData}
          onClose={handleHideInvoiceModal}
          handlePrintData={handlePrintData}
        />
        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div
            className="h-[71vh] overflow-y-auto scrollbar-hidden"
            style={{
              WebkitOverflowScrolling: "touch",
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            <table className="min-w-full border-collapse">
              <thead
                className={`bg-blue-50 sticky top-0 z-0 ${lang === "Arabic" ? "text-right" : "text-left"
                  }`}
              >
                <tr>
                  <th
                    className={`px-1 py-3 text-left text-xs font-medium text-gray-700 ${lang === "Arabic" ? "text-right" : "text-left"
                      }`}
                  ></th>
                  {[
                    t("orders.orderID"),
                    t("orders.sapOrderID"),
                    t("orders.orderCreatedDate"),
                    t("orders.addressTitle"),
                    t("orders.status"),
                    t("orders.deliveryID"),
                    t("orders.eta"),
                    t("orders.deliveryDate"),
                    t("orders.invoice"),
                    t("orders.invoiceDate"),
                    t("createOrder.CancelledBy"),
                    "Actions",
                  ].map((header) => (
                    <th
                      key={header}
                      className={`px-6 py-3 text-left text-xs text-gray-900 font-semibold ${lang === "Arabic" ? "text-right" : "text-left"
                        }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              {!loading ? (
                <tbody className="divide-y divide-gray-200">
                  {tableData.map((row, index) => (
                    <React.Fragment key={index}>
                      <tr className="">
                        {row.deliveries.length > 0 ||
                          row.invoices.length > 0 ? (
                          <td
                            className="px-2 text-sm text-gray-900 align-middle h-12 w-12"
                            onClick={() => toggleRow(index)}
                          >
                            {expandedRows.includes(index) ? (
                              <img src={down} alt="down" />
                            ) : (
                              <img src={left} alt="up" />
                            )}

                          </td>
                        ) : (
                          <td></td>
                        )}
                                                 <td
                           onClick={() => handleShowModal(row.orderId)}
                           className="px-6 py-4 text-xs text-gray-900 cursor-pointer "
                         >
                           {row.orderId || ""}
                         </td>
                         <td className="px-6 py-4 text-xs text-gray-900">
                           {row.SAPOrderId || ""}
                         </td>
                         <td className="px-6 py-4 text-xs text-gray-900">
                           {formatDateTime(row.orderCreatedDate, "date&time") ||
                             ""}
                         </td>
                         <td className="px-6 py-4 text-xs text-gray-900">
                           {row.addressTitle || ""}
                         </td>
                        <td className="px-6 py-4 text-xs">
                          <span
                            className={`inline-flex items-center justify-center w-24 text-center px-2 py-1 text-xs border-[1px] rounded-md ${statusClasses(
                              row.status
                            )}`}
                          >
                            {row.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-xs text-gray-900"></td>
                        <td className="px-6 py-4 text-xs text-gray-900"></td>
                        <td className="px-6 py-4 text-xs text-gray-900"></td>
                                                 <td className="px-6 py-4 text-xs text-blue-500 font-bold cursor-pointer">
                           {row.invoices.length > 0 ? (
                             <a
                               href={row.invoices[0].invoicePath}
                               target="_blank"
                               rel="noopener noreferrer"
                               onClick={() =>
                                 handleShowInvoiceModal(row.invoices[0].invoiceId)
                               }
                             >
                               {row.invoices[0].sap_invoice_id || ""}
                             </a>
                           ) : (
                             ""
                           )}
                         </td>
                         <td className="px-6 py-4 text-xs text-gray-900">
                           {row.invoices.length > 0
                             ? formatDateTime(row.invoices[0].invoiceDate, "date") || ""
                             : ""}
                         </td>
                        <td className="px-6 py-4 text-xs text-gray-900"></td>
                        <td className="px-6 py-4 text-xs text-gray-900">
                          {" "}
                          {row.cancel_by || "-"}
                        </td>
                        <td
                          className={`px-6 py-4 text-xs text-gray-900 cursor-pointer relative ${lang === "Arabic" ? "text-left" : "text-right"
                            }`}
                        >
                          {row.order_update && (
                            <button
                              onClick={() => toggleMenu(row.orderId)}
                              className="text-gray-500 hover:text-gray-800"
                            >
                              <p className={`text-lg`}>⋮</p>
                            </button>
                          )}
                          {menuOpen === row.orderId && (
                            <div
                              ref={dropdownRef}
                              className={`absolute -mt-5 w-32 bg-white border border-gray-200 shadow-lg rounded z-10 ${lang === "Arabic" ? "left-10" : "right-10"
                                }`}
                            >
                              <ul className="py-1 text-sm text-gray-900">
                                <li
                                  className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                  onClick={() => handleEditMedia()}
                                >
                                  {t("createOrder.edit")}
                                </li>
                                <li
                                  className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                  onClick={() => setDeleteModalOpen(true)}
                                >
                                  {t("createOrder.delete")}
                                </li>
                                {deleteModalOpen && (
                                  <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                                    <div className="bg-white p-6 rounded shadow-lg">
                                      <p className="text-sm mb-4">
                                        <div className="text-left">
                                          {t(
                                            "createOrder.Are_you_sure_you_want_to_delete_this_order?"
                                          )}
                                          <br />
                                          Order :#{row.orderId}
                                        </div>
                                      </p>
                                      <div>
                                        <select
                                          onChange={(e) => {
                                            setCancelReason(e.target.value);
                                            setCancelReasonError(false);
                                          }}
                                          className={`w-full border border-gray-300 rounded p-2 mb-4 ${cancelReasonError
                                              ? "border-red-500"
                                              : ""
                                            }`}
                                        >
                                          <option value="" disabled selected>
                                            Select an option
                                          </option>
                                          <option value="16">
                                            {t(
                                              "createOrder.CUSTOMER_CANCELLED"
                                            )}
                                          </option>
                                          <option value="63">
                                            {t("createOrder.POSTPONE_DELIVERY")}
                                          </option>
                                          <option value="40">
                                            {t("createOrder.ORDER_DUPLICATE")}
                                          </option>
                                          <option value="44">
                                            {t(
                                              "createOrder.WRONG_QUANTITY_SKU"
                                            )}
                                          </option>
                                        </select>
                                        {cancelReasonError && (
                                          <p className="text-red-500 text-xs -mt-3 mb-3 text-start">
                                            {t(
                                              "createOrder.cancel_reason_is_required"
                                            )}
                                          </p>
                                        )}
                                      </div>
                                      <div className="flex justify-end gap-5">
                                        <button
                                          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                                          onClick={() =>
                                            setDeleteModalOpen(false)
                                          }
                                        >
                                          <span className="flex items-center gap-2">
                                            {/* <span>{t("createOrder.cancel")}</span> */}
                                            <button
                                              className="text-gray-500 hover:text-gray-800"
                                              onClick={() =>
                                                setDeleteModalOpen(false)
                                              }
                                            >
                                              Close
                                            </button>
                                          </span>
                                        </button>
                                        <button
                                          className="px-4 py-2 bg-[#005879] text-white rounded hover:bg-[#005854]"
                                          onClick={() => {
                                            handleDeleteOrder(row.orderId);
                                            // setDeleteModalOpen(false);
                                          }}
                                        >
                                          {t("createOrder.delete")}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </ul>
                            </div>
                          )}
                        </td>
                      </tr>
                      {expandedRows.includes(index) && (
                        <>
                          {row.deliveries.map((delivery, subIndex) => (
                            <tr
                              key={`shipment-${subIndex}`}
                              className="bg-gray-50"
                            >
                              <td className="px-1 py-4 text-xs text-gray-900"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                                                             <td
                                 onClick={() =>
                                   handleShowDeliveryModal(
                                     delivery.sap_delivery_id,
                                     row.orderId
                                   )
                                 }
                                 className="px-6 py-4 text-xs text-blue-500 font-bold cursor-pointer"
                               >
                                 {delivery.sap_delivery_id || ""}
                               </td>
                               <td className="px-6 py-4 text-xs text-gray-900">
                                 {formatDateTime(
                                   row.estimatedDeliveryDatetime,
                                   ""
                                 ) || ""}
                               </td>
                              <td className="px-6 py-4 text-xs text-gray-900">
                                {delivery.deliveryDate
                                  ? formatDateTime(
                                    delivery.deliveryDate,
                                    "date"
                                  )
                                  : "-"}
                              </td>
                              <td className="px-6 py-4 text-xs text-blue-500 font-bold"></td>
                              <td className="px-6 py-4 text-xs text-gray-900"></td>
                            </tr>
                          ))}
                        </>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              ) : (
                <tbody className="h-48">
                  <tr>
                    <td colSpan={10} className="h-40 text-center align-middle">
                      <div className="flex justify-center items-center h-full">
                        <Loader />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            {tableData.length === 0 && !loading && (
              <p className="text-center text-sm mt-3">
                {lang === "Arabic" ? "لا يوجد بيانات" : "No Data Found"}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderTable;
